export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '6',
    active: false,
    col: 'select-btn'
  },
  {
    title: '',
    colSize: '4',
    active: false,
    col: 'photo',
    type: 'image'
  },
  {
    title: 'File type',
    colSize: '5',
    active: false,
    col: 'file_type'
  },
  {
    title: 'File name',
    colSize: '20',
    active: false,
    col: 'filename',
  }
];
